import React from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import '../../../assets/css/dashboard.css';
import { api_srv } from 'services';
import { useQuery } from 'react-query';

const Container = styled.div`
  max-width: 100%;
  padding: 10px;
  font-family: Arial, sans-serif;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
`;

const Title = styled.h2`
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 15px;
`;

const Subtitle = styled.h3`
  color: #555;
  font-size: 1.2rem;
  margin: 10px 0;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
`;

const Label = styled.span`
  font-weight: bold;
  color: #444;
`;

const Value = styled.span`
  color: #666;
`;

const LoadingMessage = styled.div`
  text-align: center;
  color: #555;
`;

const ErrorMessage = styled.div`
  text-align: center;
  color: #d32f2f;
`;

const CommissionDetails = ({ data }) => (
  <Card>
    {/* <Title>Commission Details</Title> */}
    <InfoRow>
      <Label>ID</Label>
      <Value>{data.id}</Value>
    </InfoRow>
    <InfoRow>
      <Label>Amount</Label>
      <Value>{data.amount} {data.currency}</Value>
    </InfoRow>
    <InfoRow>
      <Label>Commission Applied</Label>
      <Value>{data.commisionApplied}%</Value>
    </InfoRow>
    <InfoRow>
      <Label>Created At</Label>
      <Value>{new Date(data.createdAt).toLocaleString()}</Value>
    </InfoRow>
    <InfoRow>
      <Label>Settlement Status</Label>
      <Value>{data.settlmentTransaction.settlementStatus}</Value>
    </InfoRow>
    <InfoRow>
      <Label>Settlement Remarks</Label>
      <Value>{data.settlmentTransaction.settledRemarks}</Value>
    </InfoRow>
  </Card>
);

const UnderwriterDetails = ({ underwriter }) => (
  <Card>
    <Title>Underwriter Details</Title>
    <InfoRow>
      <Label>Name</Label>
      <Value>{underwriter[0].name}</Value>
    </InfoRow>
    <InfoRow>
      <Label>Licence Number</Label>
      <Value>{underwriter[0].licenceNumber}</Value>
    </InfoRow>
    <InfoRow>
      <Label>Category</Label>
      <Value>{underwriter[0].category}</Value>
    </InfoRow>
    <InfoRow>
      <Label>Emails</Label>
      <Value>{underwriter[0].emails.join(', ')}</Value>
    </InfoRow>
    <InfoRow>
      <Label>Contacts</Label>
      <Value>{underwriter[0].contacts.join(', ')}</Value>
    </InfoRow>
  </Card>
);

const ProductDetails = ({ product }) => (
  <Card>
    <Title>Product Details</Title>
    <InfoRow>
      <Label>Product Name</Label>
      <Value>{product[0].productName}</Value>
    </InfoRow>
    <InfoRow>
      <Label>Insurance Category</Label>
      <Value>{product[0].insuranceCategory}</Value>
    </InfoRow>
    <InfoRow>
      <Label>Insurance Class</Label>
      <Value>{product[0].insuranceClass}</Value>
    </InfoRow>
    <InfoRow>
      <Label>Base Premium Rate</Label>
      <Value>{product[0].basePremiumRate.value} ({product[0].basePremiumRate.rateType})</Value>
    </InfoRow>
    <InfoRow>
      <Label>Supported Currency</Label>
      <Value>{product[0].supportedCurrency.join(', ')}</Value>
    </InfoRow>
  </Card>
);

function ViewIntermeediaryCommissionDetails(props) {
  // Fetch commission details for a specific commission ID
  const getIntermediaryCommissionDetails = async (commissionId) => {
    if (!commissionId) return null; // Prevent fetching if commissionId is null
    let resp = await (await api_srv).fetchIntermediaryCommisionDetails(commissionId);
    return resp.data;
  };

  const {
    isLoading: isCommissionDetailsLoading,
    isError: isCommissioDetailsError,
    isSuccess: isCommissionDetailsSuccess,
    data: comissionDetails,
    error,
  } = useQuery(
    ['intermediaryCommissionsDetails', props.selectedCommissionId],
    () => getIntermediaryCommissionDetails(props.selectedCommissionId),
    {
      enabled: !!props.selectedCommissionId, // Only run query if systemQuotationRef exists
      retry: 2, // Retry failed requests twice
      staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
    }
  );

  let details = {};
  if (comissionDetails) {
    details = comissionDetails[0];
  }
  console.log('data deta666666666b6 ========', details);

  return (
    <div>
      <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Commission Details</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            {isCommissionDetailsLoading && <LoadingMessage>Loading...</LoadingMessage>}
            {isCommissioDetailsError && <ErrorMessage>Error: {error?.message || 'Failed to load data'}</ErrorMessage>}
            {isCommissionDetailsSuccess && details && (
              <>
                <CommissionDetails data={details} />
                {details.underwriter && <UnderwriterDetails underwriter={details.underwriter} />}
                {details.product_details && <ProductDetails product={details.product_details} />}
              </>
            )}
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ViewIntermeediaryCommissionDetails;